// ======================================================================
// File Name       : ServiceGroupServiceRelation
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Form } from 'react-bootstrap';

class ServiceGroupServiceRelation extends Component {
  render() {
    const { editingServiceGroupService } = this.props;
    const editingServiceGroup = Object.keys(editingServiceGroupService).sort((a, b) => {
      if (editingServiceGroupService[a].addNew && !editingServiceGroupService[b].addNew) {
        return -1;
      } if (!editingServiceGroupService[a].addNew && editingServiceGroupService[b].addNew) {
        return 1;
      }
      if (editingServiceGroupService[a].index < editingServiceGroupService[b].index) {
        return -1;
      } if (editingServiceGroupService[a].index > editingServiceGroupService[b].index) {
        return 1;
      }
      return 0;
    });

    return (
      <Form.Group>
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          <Col className="margin-left-15 margin-bottom-5" sm={3}>所属サービス</Col>
        </Col>
        <Col sm={12}>
          <Table striped hover className="margin-bottom-0 margin-left-15">
            <thead>
              <tr>
                <th>サービスコード</th>
                <th>サービス名</th>
              </tr>
            </thead>
            <tbody>
              {editingServiceGroup.map((serviceCd, index) => {
                const data = editingServiceGroupService[serviceCd]
                  ? editingServiceGroupService[serviceCd]
                  : {};
                return (
                  <tr key={index}>
                    <td>{data.serviceCd || ''}</td>
                    <td>{data.serviceName || ''}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Form.Group>
    );
  }
}

ServiceGroupServiceRelation.propTypes = {
  editingServiceGroupService: PropTypes.shape().isRequired,
};

export default ServiceGroupServiceRelation;
